import InputAdornment from "@material-ui/core/InputAdornment";
import t from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import CommonButton from "@app/common/components/material_ui/Button";
import { TextField } from "juno-shared-components";
import { ReactComponent as Visibility } from "@app/assets/svgs/view-1.svg";
import { ReactComponent as VisibilityOff } from "@app/assets/svgs/view-off.svg";
import { Link } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import { useState } from "react";
import { Trans } from "@lingui/macro";
import { css } from "@emotion/react";
import StreamlineIconWrapper from "@app/common/components/StreamlineIconWrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrosoft } from "@fortawesome/free-brands-svg-icons";

const USERNAME_VALUE = 0;
const PASSWORD_LOGIN = 1;
const TREATMENT_CODE_LOGIN = 2;


const propTypes = {
  presentationMode: t.number.isRequired,
  username: t.string.isRequired,
  isShowPassword: t.bool.isRequired,
  changeUsername: t.func.isRequired,
  errors: t.array,
  password: t.object.isRequired,
  checkInputFormat: t.func.isRequired,
  isLoading: t.bool.isRequired,
  fullname: t.string.isRequired,
  changeFullname: t.func.isRequired,
  backButtonClick: t.func.isRequired,
  handleSocialLink: t.func.isRequired,
  updateState: t.func.isRequired,
  ErrorMessage: t.oneOfType([t.object, t.array]),
};


const rootStyle = () => css`
  .not-authenticated-submit {
    margin-top: 16px,
  }

  .password-input path {
    stroke: #666;
  }
  .MuiInputBase-root {
    padding-right: 0 !important;
  }
  input {
    width: 90%;
    margin-left: auto;
    padding-left: 4em !important;
    padding-right: 1.5em  !important;
  }
  .css-71bbto-StreamlineIconWrapper {
    padding-left: 1.5rem !important;
  }
  .MuiInputAdornment-root {
    padding-left: 0.4rem !important;
  }

  .body1-text-wrapper {
    text-align: center !important;
    padding-right: 1.5rem
  }

  .providers-wrapper {
    margin-block: 0.5rem;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.8rem;
      text-decoration: none;
      outline: 2px solid black;
      padding: 0.5rem 0.8rem 0.5rem 0.5rem;
      border-radius: 1.5rem;
    }
  }
`;

const UserNotAuthenticated = (props) => {
  const {
    presentationMode,
    username,
    isShowPassword,
    changeUsername,
    errors, password,
    checkInputFormat,
    isLoading, fullname,
    changeFullname,
    backButtonClick,
    handleSocialLink,
    updateState,
    ErrorMessage } = props;
  const [disabledButton, setDisabledButton] = useState(true);
  const checkFullNameEmptyField = () => fullname.trim() === "" && presentationMode === TREATMENT_CODE_LOGIN;
  const checkEmptyFields = () => {
    if (presentationMode === TREATMENT_CODE_LOGIN) {
      return checkFullNameEmptyField();
    }
    if (presentationMode === PASSWORD_LOGIN) {
      return disabledButton;
    }
  };
  document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");


  const checkValue = () => {
    if (presentationMode === PASSWORD_LOGIN) {
      password.current?.value.trim() !== "" ? setDisabledButton(false) : setDisabledButton(true);
    }
  };

  return (
    <div css={rootStyle}>
      {presentationMode === USERNAME_VALUE && (
      <>
        <div className="body1" style={{ textAlign: "center" }}>
          <Trans>Enter your username, class code or student code</Trans>
        </div>
        {sessionStorage.getItem("DisplaySessionTimeoutMessage") && (
          <div style={{ textAlign: "justify", textAlignLast: "center", color: "red", marginTop: 20 }}>
            <Trans>
              You weren&apos;t clicking or scrolling around anymore, so we logged you out to protect your data. To go back in again, just log in.
            </Trans>
          </div>
        )}
        <FormControl margin="normal" required fullWidth>
          <Trans render={trans => (
            <TextField
              placeholder={trans.translation}
              id="username"
              name="username"
              autoFocus
              size="medium"
              value={username}
              onChange={(e) => changeUsername(e)}
            />
          )}
          >
            For Example: Username/QWE-123-456/AD-123-456
          </Trans>
          
           
        </FormControl>
      </>
      )}
      {presentationMode === PASSWORD_LOGIN && (
      <>
        <div className="body1 body1-text-wrapper">
          <Trans>Enter your Password</Trans>
        </div>
        <div className="text-field-wrapper password-input">
          <FormControl margin="normal" required fullWidth>
            <Trans render={trans => (
              <TextField
                error={errors && errors.length > 0}
                inputRef={password}
                variant="outlined"
                name="password"
                placeholder={trans.translation}
                type={isShowPassword ? "text" : "password"}
                id="password"
                autoFocus
                autoComplete="current-password"
                onChange={() => checkValue()}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" onClick={() => updateState("isShowPassword", !isShowPassword)}>
                      <StreamlineIconWrapper>{isShowPassword ? <Visibility size={10} /> : <VisibilityOff size={10} />}</StreamlineIconWrapper>
                    </InputAdornment>
                  ),
                }}
              />
            )}
            >Password
            </Trans>
          </FormControl>
        </div>
      </>
      )}
      {presentationMode === TREATMENT_CODE_LOGIN && (
      <FormControl margin="normal" required fullWidth>
        <span><Trans>Please enter your full name</Trans></span>
        <Trans render={word => (
          <TextField
            placeholder={word.translation}
            id="fullname"
            name="fullname"
            autoFocus
            value={fullname}
            onChange={changeFullname}
          />
        )}
        >Full Name
        </Trans>
      </FormControl>
      )}
      {ErrorMessage}
      {presentationMode === USERNAME_VALUE && (
      <>
        <div className="buttonWrapper">
          <CommonButton
            fullWidth
            size="large"
            color="primary"
            className="not-authenticated-submit"
            disabled={isLoading || username.trim() === ""}
            onClick={() => {
              sessionStorage.removeItem("DisplaySessionTimeoutMessage");
              checkInputFormat();
            }}
          >
            {isLoading
              ? <CircularProgress size={24} />
              : <Trans>Next</Trans>}
          </CommonButton>
        </div>
        <Link
          style={{ textAlign: "left", paddingRight: "24px", marginLeft: "18rem" }}
          to="/password"
          onClick={() => { localStorage.removeItem("access_token"); localStorage.removeItem("totp_token"); }}
        >
          <Trans>Forgot password</Trans>?
        </Link>
        <div className="horizontal-container">
          <hr />
          <span className="body2 or-label"><Trans>Or Login with</Trans></span>
          <hr />
        </div>
        <div className="providers-wrapper">
          <Link
            to="login"
            className={`not-authenticated-submit ${(isLoading) ? "disabled" : ""}`}
            onClick={() => handleSocialLink("azuread")}
          >
            <FontAwesomeIcon icon={faMicrosoft} size="2x" />
            <Trans>Microsoft</Trans>
          </Link>
        </div>
      </>
      )}
      {presentationMode !== USERNAME_VALUE && (
      <div className="buttonWrapper">
        <CommonButton
          type="submit"
          fullWidth
          size="large"
          variant="contained"
          color="primary"
          className="not-authenticated-submit"
          disabled={isLoading || checkEmptyFields()}
        //   disabled={disabledButton}
        >
          {isLoading ? (
            <CircularProgress size={24} />
          ) : (
            <Trans>Login</Trans>
          )}
        </CommonButton>
      </div>
      )}
      {presentationMode !== USERNAME_VALUE && (
      <div className="buttonWrapper">
        <CommonButton
          fullWidth
          size="large"
          variant="contained"
          color="secondary"
          className="not-authenticated-submit"
          onClick={() => backButtonClick()}
        >
          <Trans>Back</Trans>
        </CommonButton>
      </div>
      )}
      {presentationMode === PASSWORD_LOGIN && (
      <Link
        style={{ textAlign: "left", paddingLeft: "24px" }}
        to="/password"
        onClick={() => { localStorage.removeItem("access_token"); localStorage.removeItem("totp_token"); }}
      >
        <Trans>Forgot password</Trans>?
      </Link>
      ) }
    </div>
  );
};
UserNotAuthenticated.propTypes = propTypes;

export default UserNotAuthenticated;
